import React from "react"
import { useTranslation } from "react-i18next"

import { moment } from "utils"
import { DatePickerWithInput } from "components"
import RrhBranchSelect from "./RrhBranchSelect"
import RrhAccessSelect from "./RrhAccessSelect"
import RrhUserSelect from "./RrhUserSelect"
import RrDispatchedSelect from "./RrDispatchedSelect"
import classes from "./RrHeader.module.scss"
import clsx from "clsx"

const RrHeader = props => {
  const { filter, setFilter } = props

  const [t, i18n] = useTranslation()

  const handleChangeDate = (value) => {
    if (!value) {
      setFilter(prev => ({
        ...prev,
        fromDate: "",
        toDate: ""
      }))

      return
    }

    const fromDate =
      moment(value).startOf("day").toISOString()

    const toDate =
      moment(value).endOf("day").toISOString()

    setFilter(prev => ({
      ...prev,
      fromDate,
      toDate
    }))
  }

  const handleChangeDispatchDate = (value) => {
    if (!value) {
      setFilter(prev => ({
        ...prev,
        fromDispatchedAt: "",
        toDispatchedAt: ""
      }))

      return
    }

    const fromDispatchedAt =
      moment(value).startOf("day").toISOString()

    const toDispatchedAt =
      moment(value).endOf("day").toISOString()

    setFilter(prev => ({
      ...prev,
      fromDispatchedAt,
      toDispatchedAt
    }))
  }

  const handleChangeDeliveredDate = (value) => {
    if (!value) {
      setFilter(prev => ({
        ...prev,
        fromDeliveredAt: "",
        toDeliveredAt: ""
      }))

      return
    }

    const fromDeliveredAt =
      moment(value).startOf("day").toISOString()

    const toDeliveredAt =
      moment(value).endOf("day").toISOString()

    setFilter(prev => ({
      ...prev,
      fromDeliveredAt,
      toDeliveredAt
    }))
  }

  const isLtr = i18n.dir(i18n.language) === "ltr"

  return (
    <div className={classes["header"]}>
      <DatePickerWithInput
        isClearable
        type="datePicker"
        label={t("تاریخ_تکمیل_سفارش")}
        maxDate={moment().toISOString()}
        onChange={handleChangeDeliveredDate}
        value={filter.fromDeliveredAt}
        className={clsx(
          classes["input"],
          isLtr && classes["input-ltr"]
        )}
      />

      <DatePickerWithInput
        isClearable
        type="datePicker"
        label={t("تاریخ_خروج")}
        maxDate={moment().toISOString()}
        onChange={handleChangeDispatchDate}
        value={filter.fromDispatchedAt}
        className={clsx(
          classes["input"],
          isLtr && classes["input-ltr"]
        )}
      />

      <DatePickerWithInput
        type="datePicker"
        label={t("تاریخ_ثبت_سفارش")}
        maxDate={moment().toISOString()}
        onChange={handleChangeDate}
        value={filter.fromDate}
        className={clsx(
          classes["input"],
          isLtr && classes["input-ltr"]
        )}
      />

      <RrhBranchSelect
        filter={filter}
        setFilter={setFilter}
      />

      <RrhAccessSelect
        filter={filter}
        setFilter={setFilter}
      />

      <RrhUserSelect
        filter={filter}
        setFilter={setFilter}
      />

      <RrDispatchedSelect
        filter={filter}
        setFilter={setFilter}
      />
    </div>
  )
}

export default RrHeader